import { createAppStore } from '@store/createAppStore';

import { PlaylistsState } from './types';

const [playlistsStore, setPlaylistsStore] = createAppStore<PlaylistsState>(
  {
    playlists: [],
  },
  'playlistsStore',
);

export { playlistsStore, setPlaylistsStore };
